import { render } from "./PaystarResult.vue?vue&type=template&id=c9f698f6"
import script from "./PaystarResult.vue?vue&type=script&lang=js"
export * from "./PaystarResult.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__